import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { supabase } from '../supabase/supabase';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const { error } = await supabase.auth.signInWithPassword({
      email,
      password
    });

    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center px-8 relative">
      <div className="stark-bg" />
      
      {/* Back to Website Navigation */}
      <Link 
        to="/" 
        className="absolute top-8 left-8 md:top-12 md:left-12 flex items-center gap-3 text-white/50 hover:text-white transition-colors font-black tracking-widest text-xs uppercase z-10"
      >
        <div className="w-10 h-10 glass-card rounded-full flex items-center justify-center group-hover:bg-white/10 transition-colors">
          <SafeIcon icon={FiIcons.FiArrowLeft} className="text-lg" />
        </div>
        Return to Website
      </Link>

      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md glass-card p-12 rounded-[2.5rem] relative z-10"
      >
        <div className="flex items-center gap-3 mb-8">
          <div className="w-4 h-4 bg-stark-pink rounded-full flex items-center justify-center shadow-[0_0_15px_rgba(255,0,127,0.5)]" />
          <h2 className="text-4xl font-black uppercase tracking-tighter">Admin</h2>
        </div>

        {error && (
          <div className="p-4 bg-red-500/10 border border-red-500/20 text-red-500 rounded-xl mb-6 text-sm font-medium">
            {error}
          </div>
        )}

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="block text-xs font-black uppercase tracking-widest text-white/40 mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-white/5 border border-white/10 rounded-xl py-4 px-6 text-white focus:outline-none focus:border-stark-lime transition-colors"
              required
            />
          </div>
          <div>
            <label className="block text-xs font-black uppercase tracking-widest text-white/40 mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-white/5 border border-white/10 rounded-xl py-4 px-6 text-white focus:outline-none focus:border-stark-lime transition-colors"
              required
            />
          </div>
          <button 
            disabled={loading}
            className="w-full py-4 bg-stark-lime text-black font-black rounded-full hover:bg-white transition-all disabled:opacity-50 mt-4"
          >
            {loading ? 'AUTHENTICATING...' : 'ENTER DASHBOARD'}
          </button>
        </form>
      </motion.div>
    </div>
  );
}